<template>
	<div>
		<!-- <div>
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/GardenList' }">幼儿园管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="query" ref="query" :data="tableData">
				<div class="handle-box">
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<el-input v-model="query.name" clearable :placeholder="$t('bannerList.bannerList_1')" class="handle-input mr10"
								 style="width: 15%;"></el-input>
								<el-select v-model="query.kind" clearable :placeholder="$t('bannerList.bannerList_2')" class="handle-select mr10">
									<el-option v-for="item in query.optionsKind" :key="item.TABTYPE" :label="item.name" :value="item.TABTYPE">
									</el-option>
								</el-select>
								<el-select v-model="query.stat" clearable filterable :placeholder="$t('bannerList.bannerList_3')" class="handle-select mr10">
									<el-option v-for="item in query.optionsStat" :key="item.TABSTAT" :label="item.name" :value="item.TABSTAT">
									</el-option>
								</el-select>
							</div>
						</el-col>
						<el-col :span="2">
							<div class="grid-content bg-purple-light">
								<el-button :disabled="!hasPerms(buttonPerms.searchPerms)" type="warning" class="float" icon="el-icon-search"
								 @click="handleSearch">搜索</el-button>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<el-button :disabled="!hasPerms(buttonPerms.batchdelPerms)" type="danger" icon="el-icon-delete" class="handle-del"
								 @click="delAllSelection">{{i18n.bannerList_5}}</el-button>
							</div>
						</el-col>
						<el-col :span="2">
							<div class="grid-content bg-purple-light">
								<el-button :disabled="!hasPerms(buttonPerms.addPerms)" type="primary" icon="el-icon-plus" @click="handleAdd">{{i18n.bannerList_6}}</el-button>
							</div>
						</el-col>
					</el-row>
				</div>
			</el-form>
		</div> -->
	</div>
</template>
<script>
	export default {
		name: 'Dashboard'
	}
</script>
